import { render } from "./ColourToolbar.vue?vue&type=template&id=cf451d8e"
import script from "./ColourToolbar.vue?vue&type=script&lang=js"
export * from "./ColourToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__